import { render, staticRenderFns } from "./standards-management.vue?vue&type=template&id=58c3d098&scoped=true"
import script from "./standards-management.vue?vue&type=script&lang=js"
export * from "./standards-management.vue?vue&type=script&lang=js"
import style0 from "./standards-management.vue?vue&type=style&index=0&id=58c3d098&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58c3d098",
  null
  
)

export default component.exports